import { HOTKEY_LABELS, MODIFIER_KEY_SYMBOLS, MODIFIER_KEY_SYMBOLS_MACOS } from "./constants.js";
import { isMacOS } from "@scalar/helpers/general/is-mac-os";
//#region src/components/ScalarHotkey/formatHotkey.ts
var useMacHotkeySymbols = () => {
	return isMacOS();
};
/** Typescript helper to check if a modifier is the default modifier */
function isDefault(modifier) {
	return modifier === "default";
}
/** Get the modifier key symbol for a modifier */
function getModifierKeySymbol(modifier) {
	const hotkey = isDefault(modifier) ? "Meta" : modifier;
	return useMacHotkeySymbols() ? MODIFIER_KEY_SYMBOLS_MACOS[hotkey] : MODIFIER_KEY_SYMBOLS[hotkey];
}
/** Format the hotkey symbols for a hotkey */
function formatHotkeySymbols(hotkey, modifier) {
	return [...modifier.map((mod) => getModifierKeySymbol(mod)), hotkey];
}
/** Get the hotkey label for a hotkey */
function getKeyLabel(key) {
	return key in HOTKEY_LABELS ? HOTKEY_LABELS[key] : key;
}
//#endregion
export { formatHotkeySymbols, getKeyLabel, getModifierKeySymbol };

//# sourceMappingURL=formatHotkey.js.map